import { EntityContext } from "@common/types/entityContext";

/**
 * Demo connections are intentionally marked as errored on the backend so their
 * (fake) accounts never attempt to sync. We hide that error in the UI for demo
 * workspaces so the demo looks clean. This lives on the frontend and is gated on
 * the active workspace's `isDemo` flag so it also covers organization demo
 * workspaces, whose connections are owned by a fake (non-DEMO) user.
 */
export function clearConnectionError<T extends { error: string | null }>(
    connection: T,
): T {
    if (connection.error === null) {
        return connection;
    }
    const cleared = { ...connection };
    cleared.error = null;
    return cleared;
}

export function clearEntityContextsConnectionErrors(
    contexts: EntityContext[],
): EntityContext[] {
    return contexts.map((context) => ({
        ...context,
        financialAccounts: context.financialAccounts.map(
            (financialAccount) => ({
                ...financialAccount,
                integrationAccounts: financialAccount.integrationAccounts?.map(
                    (integrationAccount) => ({
                        ...integrationAccount,
                        connection: integrationAccount.connection
                            ? clearConnectionError(
                                  integrationAccount.connection,
                              )
                            : integrationAccount.connection,
                        integrationConnection:
                            integrationAccount.integrationConnection
                                ? clearConnectionError(
                                      integrationAccount.integrationConnection,
                                  )
                                : integrationAccount.integrationConnection,
                    }),
                ),
            }),
        ),
    }));
}
